import { render } from "./market-total-number.vue?vue&type=template&id=288a371e&scoped=true"
import script from "./market-total-number.vue?vue&type=script&lang=js"
export * from "./market-total-number.vue?vue&type=script&lang=js"

import "./market-total-number.vue?vue&type=style&index=0&id=288a371e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288a371e"]])

export default __exports__